import {handleOpenSlabModeConflict} from "../bvcomponents/sqft/components/popup/modalFix/slabFix/slabModeConflictHelper";
import {isModalFixEnabled} from "../bvcomponents/sqft/components/popup/modalFix/modalFixConfig";
import store from "../store";
import {setWizardConflictPopupOpened} from "../actions/wizardFunctions";

/**
 * Checks whether the current wizard conflicts can be shown by the active conflict UI.
 *
 * Wizard conflicts can point either to real cart items or to temporary SQFT cart
 * items prepared before Update Cart. The legacy popup can only show real cart items;
 * temporary SQFT items are supported only by the modal-fix flow.
 *
 * Without this guard, SQFT apply can be blocked by a conflict popup that opens with
 * no actionable item.
 */
export const canOpenWizardConflictPopup = (state) => {
  const {wizardConflictingSteps} = state.wizardState;
  const {cartItems} = state.cartState;
  const {sqftCartItems} = state.sqftResourceState;
  const canUseSqftTempItems = isModalFixEnabled();

  return wizardConflictingSteps.some((conflictingStep) => {
    return cartItems.some((cartItem) => cartItem.id === conflictingStep.cartItemId)
      || (
        canUseSqftTempItems
        && sqftCartItems.some((cartItem) => cartItem.id === conflictingStep.cartItemId)
      );
  });
};

export const handleOpenConflictPopups = () => {
  const state = store.getState();
  const {wizardConflictingSteps} = state.wizardState;
  if (wizardConflictingSteps.length && canOpenWizardConflictPopup(state)) {
    store.dispatch(setWizardConflictPopupOpened(true));
  } else  {
    handleOpenSlabModeConflict().then(() => undefined);
  }
}
